<!-- Página de Registro — TecGurus Empleos -->

<!-- Loading overlay (OAuth) -->
<div *ngIf="cargandoSocial"
     class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-white/80 tw-backdrop-blur-sm">
  <div class="tw-text-center">
    <div class="tw-mx-auto tw-w-12 tw-h-12 tw-rounded-full tw-border-4 tw-border-blue-100 tw-border-t-blue-600 tw-animate-spin"></div>
    <p class="tw-mt-3 tw-text-slate-600 tw-font-medium">Creando cuenta…</p>
  </div>
</div>

<!-- ── 3-column layout ─────────────────────────────────────────────────────── -->
<div class="tw-bg-slate-50 lg:tw-flex tw-items-start">

  <!-- ── LEFT PANEL: Brand ──────────────────────────────────────────────────── -->
  <div class="tw-hidden lg:tw-flex tw-flex-col tw-justify-center tw-w-72 tw-shrink-0 tw-px-10 tw-sticky tw-top-0"
       style="background:linear-gradient(160deg,#0f172a 0%,#1e3a5f 50%,#1d4ed8 100%);height:calc(100vh - 64px);overflow:hidden">

    <h1 class="tw-text-3xl tw-font-extrabold tw-text-white tw-leading-tight">
      Únete a<br>TecGurus Empleos
    </h1>
    <p class="tw-mt-3 tw-text-blue-200 tw-text-sm tw-leading-relaxed">
      Crea tu cuenta gratis y accede a las mejores oportunidades tech del mercado.
    </p>

    <ul class="tw-mt-8 tw-space-y-5">
      <li class="tw-flex tw-items-start tw-gap-3 tw-text-white tw-text-sm">
        <div class="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
          <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"/>
          </svg>
        </div>
        <span class="tw-leading-snug">GuruMatch IA — matchea tu CV con vacantes reales</span>
      </li>
      <li class="tw-flex tw-items-start tw-gap-3 tw-text-white tw-text-sm">
        <div class="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
          <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
          </svg>
        </div>
        <span class="tw-leading-snug">Análisis de CV con retroalimentación profesional</span>
      </li>
      <li class="tw-flex tw-items-start tw-gap-3 tw-text-white tw-text-sm">
        <div class="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
          <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <span class="tw-leading-snug">Plan gratuito — sin tarjeta de crédito</span>
      </li>
    </ul>
  </div>

  <!-- ── CENTER: Registration Card ─────────────────────────────────────────── -->
  <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-6">
    <div class="tw-w-full tw-max-w-lg">

      <!-- ─── PASO 1: Selector de rol ──────────────────────────────────────── -->
      <div *ngIf="pasoRegistro === 1">
        <div class="tw-bg-white tw-rounded-2xl tw-shadow-xl tw-p-8">

          <!-- Header -->
          <div class="tw-text-center tw-mb-8">
            <div class="tw-w-12 tw-h-12 tw-mx-auto tw-mb-3 tw-rounded-xl tw-bg-blue-50 tw-flex tw-items-center tw-justify-center">
              <svg class="tw-w-6 tw-h-6 tw-text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"/>
              </svg>
            </div>
            <h2 class="tw-text-2xl tw-font-bold tw-text-slate-900">¿Cómo quieres unirte?</h2>
            <p class="tw-mt-1.5 tw-text-sm tw-text-slate-500">Elige tu tipo de cuenta para continuar</p>
          </div>

          <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-5">

            <!-- Candidato -->
            <button type="button" (click)="elegirRol('candidato')"
                    class="tw-group tw-relative tw-flex tw-flex-col tw-items-center tw-gap-4 tw-p-7
                           tw-rounded-2xl tw-border-2 tw-border-slate-200 tw-bg-slate-50
                           hover:tw-border-blue-500/60 hover:tw-bg-blue-50
                           tw-cursor-pointer tw-transition tw-duration-200 tw-text-left">
              <div class="tw-w-14 tw-h-14 tw-rounded-xl tw-bg-blue-100 tw-flex tw-items-center tw-justify-center
                          group-hover:tw-bg-blue-200 tw-transition">
                <svg class="tw-w-7 tw-h-7 tw-text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/>
                </svg>
              </div>
              <div class="tw-text-center">
                <p class="tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-1">Soy Candidato</p>
                <p class="tw-text-sm tw-text-slate-500 tw-leading-relaxed">
                  Busco empleo tech y quiero postularme a las mejores empresas
                </p>
              </div>
              <div class="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-semibold tw-text-blue-600 tw-mt-1">
                <span>Registro gratuito</span>
                <svg class="tw-w-3.5 tw-h-3.5 tw-group-hover:tw-translate-x-0.5 tw-transition" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/>
                </svg>
              </div>
            </button>

            <!-- Empresa -->
            <button type="button" (click)="elegirRol('empresa')"
                    class="tw-group tw-relative tw-flex tw-flex-col tw-items-center tw-gap-4 tw-p-7
                           tw-rounded-2xl tw-border-2 tw-border-slate-200 tw-bg-slate-50
                           hover:tw-border-indigo-500/60 hover:tw-bg-indigo-50
                           tw-cursor-pointer tw-transition tw-duration-200 tw-text-left">
              <div class="tw-w-14 tw-h-14 tw-rounded-xl tw-bg-indigo-100 tw-flex tw-items-center tw-justify-center
                          group-hover:tw-bg-indigo-200 tw-transition">
                <svg class="tw-w-7 tw-h-7 tw-text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"/>
                </svg>
              </div>
              <div class="tw-text-center">
                <p class="tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-1">Soy Empresa</p>
                <p class="tw-text-sm tw-text-slate-500 tw-leading-relaxed">
                  Publico vacantes y busco candidatos tech calificados con IA
                </p>
              </div>
              <div class="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-semibold tw-text-indigo-600 tw-mt-1">
                <span>Empieza gratis</span>
                <svg class="tw-w-3.5 tw-h-3.5 tw-group-hover:tw-translate-x-0.5 tw-transition" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/>
                </svg>
              </div>
            </button>

          </div>

          <p class="tw-text-center tw-mt-6 tw-text-sm tw-text-slate-500">
            ¿Ya tienes cuenta?
            <a routerLink="/acceder" class="tw-font-semibold tw-text-blue-600 hover:tw-underline">
              Inicia sesión aquí
            </a>
          </p>
        </div>
      </div>

      <!-- ─── PASO 2: Método de registro ─────────────────────────────────────── -->
      <div *ngIf="pasoRegistro === 2">
        <div class="tw-bg-white tw-rounded-2xl tw-shadow-xl tw-p-8">

          <!-- Header del paso 2 -->
          <div class="tw-flex tw-items-center tw-justify-between tw-mb-6">
            <button type="button" (click)="pasoRegistro = 1"
                    class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-500 hover:tw-text-slate-900 tw-transition tw-cursor-pointer tw-bg-transparent tw-border-0">
              <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"/>
              </svg>
              Cambiar tipo de cuenta
            </button>

            <!-- Role badge -->
            <span class="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold tw-tracking-wide"
                  [ngClass]="tipoRegistro === 'candidato'
                    ? 'tw-bg-blue-100 tw-text-blue-700'
                    : 'tw-bg-indigo-100 tw-text-indigo-700'">
              <svg *ngIf="tipoRegistro === 'candidato'" class="tw-w-3.5 tw-h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0"/>
              </svg>
              <svg *ngIf="tipoRegistro === 'empresa'" class="tw-w-3.5 tw-h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18"/>
              </svg>
              {{ tipoRegistro === 'candidato' ? 'Candidato' : 'Empresa' }}
            </span>
          </div>

          <div class="tw-text-center tw-mb-6">
            <h2 class="tw-text-2xl tw-font-bold tw-text-slate-900">Crea tu cuenta</h2>
            <p *ngIf="tipoRegistro === 'candidato'" class="tw-mt-1.5 tw-text-slate-500 tw-text-sm">
              Entra rápido con Google o LinkedIn — tu perfil completo lo puedes llenar después
            </p>
            <p *ngIf="tipoRegistro === 'empresa'" class="tw-mt-1.5 tw-text-slate-500 tw-text-sm">
              Con Google o LinkedIn entras en segundos y completarás tu perfil justo después
            </p>
          </div>

          <!-- WhatsApp-first — solo candidato, CTA principal -->
          <button *ngIf="tipoRegistro === 'candidato' && waStep === 'idle'" (click)="openWhatsapp()" type="button"
                  class="tw-w-full tw-h-12 tw-flex tw-items-center tw-justify-center tw-gap-2
                         tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-mb-4"
                  style="background:#25D366">
            <svg class="tw-w-5 tw-h-5" fill="currentColor" viewBox="0 0 448 512">
              <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/>
            </svg>
            Continuar con WhatsApp
          </button>

          <!-- WhatsApp: paso teléfono -->
          <div *ngIf="waStep === 'phone'" class="tw-mb-5">
            <button (click)="closeWhatsapp()" type="button"
                    class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-mb-3 tw-p-0">
              ← Volver
            </button>
            <p class="tw-text-sm tw-text-slate-600 tw-mb-3">Ingresa tu número y te enviamos un código por WhatsApp.</p>
            <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
              <select [(ngModel)]="selectedDialCode" [ngModelOptions]="{standalone: true}"
                      class="tw-py-2.5 tw-px-3 tw-rounded-xl tw-border tw-text-sm tw-bg-slate-50 tw-font-medium tw-text-slate-600 tw-outline-none"
                      [style.borderColor]="waPhoneError ? '#dc2626' : '#e2e8f0'">
                <option *ngFor="let c of countries" [value]="c.dial">{{ c.flag }} +{{ c.display }}</option>
              </select>
              <input type="tel" inputmode="numeric" [ngModel]="waPhoneNumber" (ngModelChange)="onWaPhoneChange($event)"
                     [ngModelOptions]="{standalone: true}"
                     placeholder="1122334455" maxlength="15"
                     class="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-text-sm tw-outline-none"
                     [style.borderColor]="waPhoneError ? '#dc2626' : '#e2e8f0'"
                     (keyup.enter)="sendWaOtp()">
            </div>
            <p *ngIf="waPhoneError" class="tw-text-xs tw-text-red-600 tw-mt-1">{{ waPhoneError }}</p>
            <button (click)="sendWaOtp()" [disabled]="waSendingOtp" type="button"
                    class="tw-w-full tw-mt-3 tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                    [style.background]="waSendingOtp ? '#94a3b8' : '#25D366'">
              <span *ngIf="!waSendingOtp">Enviar código por WhatsApp</span>
              <span *ngIf="waSendingOtp">Enviando...</span>
            </button>
          </div>

          <!-- WhatsApp: paso código OTP -->
          <div *ngIf="waStep === 'otp'" class="tw-mb-5 tw-text-center">
            <button (click)="closeWhatsapp()" type="button"
                    class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-mb-3 tw-p-0">
              ← Volver
            </button>
            <p class="tw-text-sm tw-text-slate-500 tw-mb-4">
              Enviamos un código a <span class="tw-font-medium">+{{ waFullPhone }}</span>
            </p>
            <input type="text" [ngModel]="waOtpCode" (ngModelChange)="onWaOtpChange($event)" [ngModelOptions]="{standalone: true}" [disabled]="waVerifyingOtp"
                   maxlength="6" inputmode="numeric" autocomplete="one-time-code"
                   placeholder="000000"
                   class="tw-w-48 tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-text-xl tw-text-center tw-tracking-[8px] tw-font-mono tw-outline-none tw-mx-auto"
                   [style.borderColor]="waOtpError ? '#dc2626' : '#e2e8f0'"
                   (keyup.enter)="verifyWaOtp()">
            <p *ngIf="waOtpError" class="tw-text-xs tw-text-red-600 tw-mt-3">{{ waOtpError }}</p>
            <button (click)="verifyWaOtp()" [disabled]="waOtpCode.length < 6 || waVerifyingOtp" type="button"
                    class="tw-w-full tw-mt-4 tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                    [style.background]="waOtpCode.length < 6 || waVerifyingOtp ? '#94a3b8' : '#25D366'">
              <span *ngIf="!waVerifyingOtp">Verificar</span>
              <span *ngIf="waVerifyingOtp">Verificando...</span>
            </button>
            <button (click)="resendWaOtp()" [disabled]="waResendCooldown > 0 || waSendingOtp" type="button"
                    class="tw-mt-4 tw-text-sm tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer"
                    [style.color]="(waResendCooldown > 0 || waSendingOtp) ? '#94a3b8' : '#25D366'">
              {{ waResendCooldown > 0 ? 'Reenviar código en ' + waResendCooldown + 's' : (waSendingOtp ? 'Enviando...' : 'Reenviar código') }}
            </button>
          </div>

          <!-- WhatsApp: confirmar cuenta existente -->
          <div *ngIf="waStep === 'confirm'" class="tw-mb-5 tw-text-center">
            <div class="tw-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-xl tw-bg-blue-100 tw-mb-4 tw-mx-auto">
              <svg class="tw-w-7 tw-h-7" style="color:#2563eb" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <p class="tw-text-sm tw-text-slate-700 tw-mb-1">Encontramos una cuenta con este número:</p>
            <p class="tw-text-sm tw-font-semibold tw-text-slate-900 tw-mb-6">{{ waMaskedEmail }}</p>
            <button (click)="resolveWa('LINK')" [disabled]="waResolving" type="button"
                    class="tw-w-full tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-mb-3"
                    style="background:#25D366">
              Sí, es mía — entrar
            </button>
            <button (click)="resolveWa('NEW')" [disabled]="waResolving" type="button"
                    class="tw-w-full tw-py-3 tw-rounded-xl tw-text-sm tw-font-medium tw-bg-transparent tw-border tw-border-slate-200 tw-cursor-pointer"
                    style="color:#475569">
              No, soy una persona distinta
            </button>
          </div>

          <ng-container *ngIf="waStep === 'idle'">
          <!-- ── Botones sociales ─── -->
          <div class="tw-space-y-3">

            <!-- Google -->
            <div id="google-btn-container-register"
                 class="tw-w-full tw-flex tw-justify-center tw-min-h-[44px]"></div>

            <!-- LinkedIn -->
            <button type="button" (click)="loginLinkedIn(tipoRegistro)"
                    class="tw-w-full tw-h-11 tw-flex tw-items-center tw-justify-center tw-gap-3
                           tw-px-4 tw-rounded-xl tw-border tw-border-slate-200
                           tw-bg-white hover:tw-bg-slate-50 tw-transition tw-duration-150
                           tw-text-sm tw-font-medium tw-text-slate-700 tw-cursor-pointer">
              <svg class="tw-w-5 tw-h-5 tw-shrink-0" viewBox="0 0 24 24" fill="#0A66C2">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              Continuar con LinkedIn
            </button>
          </div>

          <!-- Error OAuth -->
          <div *ngIf="mensajeErrorSocial"
               class="tw-mt-3 tw-flex tw-items-start tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200">
            <p class="tw-text-sm tw-text-red-600">{{ mensajeErrorSocial }}</p>
          </div>

          <!-- Separador — solo para Empresa (el formulario de correo no existe para Candidato) -->
          <div *ngIf="tipoRegistro === 'empresa'" class="tw-flex tw-items-center tw-gap-3 tw-my-6">
            <hr class="tw-flex-1 tw-border-slate-200">
            <span class="tw-text-xs tw-text-slate-400 tw-font-medium tw-whitespace-nowrap">o regístrate con correo</span>
            <hr class="tw-flex-1 tw-border-slate-200">
          </div>
          </ng-container>

          <!-- ── Formulario CANDIDATO ─── -->
          <!-- ── Formulario EMPRESA ─── -->
          <div *ngIf="tipoRegistro === 'empresa' && waStep === 'idle'">
            <form [formGroup]="formEmp" (ngSubmit)="crearCuentaEmpresarial()" novalidate class="tw-space-y-4">

              <div>
                <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Correo electrónico <span class="tw-text-red-500">*</span></label>
                <input type="email" formControlName="correo" autocomplete="email"
                       placeholder="empresa@correo.com"
                       class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                              focus:tw-ring-2 focus:tw-ring-indigo-500/30 focus:tw-border-indigo-500 tw-transition">
                <div *ngIf="formEmp.controls.correo.errors && mostrarMensajeEmpresa" class="tw-mt-1 tw-text-xs tw-text-red-500">
                  <span *ngIf="formEmp.controls.correo.errors.required">El correo es requerido.</span>
                  <span *ngIf="formEmp.controls.correo.errors.pattern">Formato de correo inválido.</span>
                </div>
                <div *ngIf="correoTemporal" class="tw-mt-1.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-amber-50 tw-border tw-border-amber-200 tw-text-xs tw-text-amber-700">
                  Los correos temporales no están permitidos. Usa tu correo real.
                </div>
              </div>

              <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">
                <div>
                  <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Contraseña <span class="tw-text-red-500">*</span></label>
                  <div class="tw-relative">
                    <input [type]="showEmpPass ? 'text' : 'password'" formControlName="password" minlength="8"
                           placeholder="Mínimo 8 caracteres"
                           class="tw-w-full tw-px-4 tw-py-2.5 tw-pr-10 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                                  focus:tw-ring-2 focus:tw-ring-indigo-500/30 focus:tw-border-indigo-500 tw-transition">
                    <button type="button" (click)="showEmpPass = !showEmpPass"
                            class="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer">
                      <svg *ngIf="!showEmpPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                      <svg *ngIf="showEmpPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                      </svg>
                    </button>
                  </div>
                  <div *ngIf="formEmp.controls.password.errors && mostrarMensajeEmpresa" class="tw-mt-1 tw-text-xs tw-text-red-500">
                    <span *ngIf="formEmp.controls.password.errors.required">Requerida.</span>
                    <span *ngIf="formEmp.controls.password.errors.minlength">Mínimo 8 caracteres.</span>
                  </div>
                </div>
                <div>
                  <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Confirmar contraseña <span class="tw-text-red-500">*</span></label>
                  <div class="tw-relative">
                    <input [type]="showEmpConfirm ? 'text' : 'password'" formControlName="confirmarPass" minlength="8"
                           placeholder="Repite tu contraseña"
                           class="tw-w-full tw-px-4 tw-py-2.5 tw-pr-10 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                                  focus:tw-ring-2 focus:tw-ring-indigo-500/30 focus:tw-border-indigo-500 tw-transition">
                    <button type="button" (click)="showEmpConfirm = !showEmpConfirm"
                            class="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer">
                      <svg *ngIf="!showEmpConfirm" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                      <svg *ngIf="showEmpConfirm" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div *ngIf="esMensajePass"
                   class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600">
                Las contraseñas no coinciden.
              </div>

              <div class="tw-flex tw-items-center tw-gap-2">
                <input class="tw-w-4 tw-h-4 tw-rounded tw-border-slate-300 tw-cursor-pointer" type="checkbox"
                       id="termsEmp" (click)="aceptoTerminoYCondiciones()">
                <label for="termsEmp" class="tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                  Acepto los <a href="https://tecgurus.net/privacidad.html" target="_blank" class="tw-text-indigo-600 hover:tw-underline">Términos y Condiciones</a>
                </label>
              </div>

              <ngx-recaptcha2 formControlName="recaptcha"
                (success)="handleSuccess($event)" (reset)="handleReset()"
                (expire)="handleExpire()" (load)="handleLoad()"
                [siteKey]="calveSitio" [size]="'normal'" [hl]="lang">
              </ngx-recaptcha2>

              <div *ngIf="esMensajeSubmit && mensajeExito"
                   class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-emerald-50 tw-border tw-border-emerald-200 tw-text-sm tw-text-emerald-700">
                {{ mensajeExito }}
                <p class="tw-mt-2 tw-text-xs">¿No llegó el correo? <a routerLink="/verificar" class="tw-font-semibold tw-underline">Reenviar código de verificación →</a></p>
              </div>
              <div *ngIf="esMensajeSubmit && mensajeError"
                   class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600">
                {{ mensajeError }}
                <div *ngIf="correoYaExiste" class="tw-mt-1.5 tw-font-medium">
                  <a routerLink="/acceder" class="tw-underline">¿Ya tienes cuenta? Iniciar sesión →</a>
                </div>
              </div>

              <!-- Info note -->
              <div class="tw-flex tw-items-start tw-gap-2 tw-px-3 tw-py-3 tw-rounded-xl tw-bg-indigo-50 tw-border tw-border-indigo-100">
                <svg class="tw-w-4 tw-h-4 tw-text-indigo-500 tw-mt-0.5 tw-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd"/>
                </svg>
                <p class="tw-text-xs tw-text-indigo-700">
                  Después de confirmar tu correo completarás el perfil de empresa (nombre comercial, RFC, etc.) para publicar vacantes.
                </p>
              </div>

              <button type="submit" [disabled]="enviandoForm"
                      class="tw-w-full tw-py-2.5 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm
                             tw-border-0 tw-transition tw-duration-150
                             disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
                      style="background:linear-gradient(135deg,#3730a3,#1d4ed8)">
                Crear cuenta empresarial
              </button>
              <p class="tw-text-center tw-text-xs tw-text-slate-500">
                ¿Cuenta pendiente de verificar?
                <a routerLink="/verificar" class="tw-text-blue-600 hover:tw-underline tw-font-medium">Reenviar código →</a>
              </p>
            </form>
          </div>



        </div><!-- end card -->

        <p class="tw-text-center tw-mt-5 tw-text-sm tw-text-slate-500">
          ¿Ya tienes cuenta?
          <a routerLink="/acceder" class="tw-font-semibold tw-text-blue-600 hover:tw-underline">Iniciar sesión</a>
        </p>
      </div><!-- end paso 2 -->

    </div>
  </div>

  <!-- ── RIGHT PANEL: Feature annotations ──────────────────────────────────── -->
  <div class="tw-hidden xl:tw-flex tw-flex-col tw-justify-start tw-w-64 tw-shrink-0 tw-px-8 tw-pt-10 tw-pb-8 tw-space-y-7 tw-sticky tw-top-0"
       style="height:calc(100vh - 64px);overflow:hidden">

    <div class="tw-flex tw-items-start tw-gap-3">
      <div class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
        <svg class="tw-w-3.5 tw-h-3.5 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
        </svg>
      </div>
      <div>
        <p class="tw-font-bold tw-text-blue-800 tw-text-sm tw-leading-snug">Selecciona tu perfil primero</p>
        <p class="tw-text-xs tw-text-slate-500 tw-mt-1 tw-leading-relaxed">Candidato o empresa, según lo que necesitas. Puedes cambiarlo después.</p>
      </div>
    </div>

    <div class="tw-flex tw-items-start tw-gap-3">
      <div class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
        <svg class="tw-w-3.5 tw-h-3.5 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
        </svg>
      </div>
      <div>
        <p class="tw-font-bold tw-text-blue-800 tw-text-sm tw-leading-snug">Registro en menos de 30 segundos</p>
        <p class="tw-text-xs tw-text-slate-500 tw-mt-1 tw-leading-relaxed">Usa Google o LinkedIn y entra sin llenar formularios largos.</p>
      </div>
    </div>

    <div class="tw-flex tw-items-start tw-gap-3">
      <div class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
        <svg class="tw-w-3.5 tw-h-3.5 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
        </svg>
      </div>
      <div>
        <p class="tw-font-bold tw-text-blue-800 tw-text-sm tw-leading-snug">Completa tu perfil cuando quieras</p>
        <p class="tw-text-xs tw-text-slate-500 tw-mt-1 tw-leading-relaxed">Solo necesitas acceso inicial. Tu perfil completo lo llenas a tu ritmo.</p>
      </div>
    </div>

  </div>

</div>
